import { MediaData } from './media-data';
import { PeriodTypeEnum } from '../../enum/period-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CompanyDetails {
  CompanyLogoUrl: string;
  CompanyName: string;
  CompanyAddress: string;
  Latitude: number;
  Longitude: number;
  EmailAddress: string;
  PhoneNumber: string;
  WebConsoleSetupComplete: boolean;
  DepotsEnabled: boolean;
  CompanyLogo: MediaData;
  PeriodType: PeriodTypeEnum;
  FirstPeriodStartDate: string;
}


